import React, { FC, useEffect } from 'react';
import './BingoPage.scss';

import { ItvGenericPage } from '../ItvGenericPage';
import { useUserContext } from '../../../providers/UserProvider';
import { BRANDS } from '../../../components/Itv/types';

export const BingoPage: FC = () => {
  const { setTheme } = useUserContext();

  useEffect(() => {
    setTheme(BRANDS.BINGO);
  }, []);

  return <ItvGenericPage variant="bingo" />;
};
